webpackJsonp([198517197184460],{

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scriptTagAdded = false; /** Copyright (c) 2017-2018 Kaj Magnus Lindberg. License: MIT. */
	
	function addScriptTagOnce() {
	  if (scriptTagAdded) return;
	
	  var scriptElem = document.createElement('script');
	  var headOrBodyElem = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
	
	  scriptElem.async = true;
	  scriptElem.type = 'text/javascript';
	  scriptElem.src = window.talkyardScriptUrl || 'https://cdn.talkyard.net/-/talkyard-comments.min.js';
	  window.talkyardServerUrl = window.talkyardServerUrl || 'https://comments-demo.talkyard.io';
	
	  headOrBodyElem.appendChild(scriptElem);
	  scriptTagAdded = true;
	}
	
	var TalkyardCommentsIframe = function (_Component) {
	  (0, _inherits3.default)(TalkyardCommentsIframe, _Component);
	
	  function TalkyardCommentsIframe(props) {
	    (0, _classCallCheck3.default)(this, TalkyardCommentsIframe);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	  }
	
	  TalkyardCommentsIframe.prototype.componentDidMount = function componentDidMount() {
	    var isReMounting = scriptTagAdded;
	    addScriptTagOnce();
	    if (isReMounting) {
	      // The user have navigated to a new page, via history.push() and un/remounting components.
	      // We need to reload comments, for this new URL.
	      // But maybe the user har clicked links to new pages super quickly, so the script hasn't
	      // loaded yet, so check if the fn exists.
	      if (window.talkyardReloadCommentsAndEditor) {
	        window.talkyardReloadCommentsAndEditor();
	      }
	    }
	  };
	
	  TalkyardCommentsIframe.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (window.talkyardRemoveCommentsAndEditor) {
	      window.talkyardRemoveCommentsAndEditor();
	    }
	  };
	
	  TalkyardCommentsIframe.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'talkyard-comments', 'data-discussion-id': this.props.discussionId || '', 'data-talkyard-page-id': this.props.talkyardPageId || this.props.edPageId || '' },
	      _react2.default.createElement(
	        'noscript',
	        null,
	        'Please enable Javascript to view comments.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { marginTop: 25, opacity: 0.9, fontSize: '96%' } },
	        'Comments powered by ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.talkyard.io' },
	          'Talkyard'
	        ),
	        '.'
	      )
	    );
	  };
	
	  return TalkyardCommentsIframe;
	}(_react.Component);
	
	exports.default = TalkyardCommentsIframe;

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 212:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(116),
	    deburr = __webpack_require__(254),
	    words = __webpack_require__(262);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(218);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(226),
	    toString = __webpack_require__(65);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(224);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(212),
	    hasUnicodeWord = __webpack_require__(231),
	    toString = __webpack_require__(65),
	    unicodeWords = __webpack_require__(253);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowLeft = function FaArrowLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.3 20v2.9q0 1.1-0.7 2t-1.9 0.8h-15.7l6.5 6.6q0.9 0.8 0.9 2t-0.9 2l-1.7 1.7q-0.8 0.8-2 0.8-1.1 0-2-0.8l-14.5-14.6q-0.9-0.8-0.9-2 0-1.1 0.9-2l14.5-14.5q0.8-0.9 2-0.9 1.2 0 2 0.9l1.7 1.6q0.9 0.9 0.9 2.1t-0.9 2l-6.5 6.5h15.7q1.1 0 1.9 0.9t0.7 2z' })
	        )
	    );
	};
	
	exports.default = FaArrowLeft;
	module.exports = exports['default'];

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowRight = function FaArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.4 21.4q0 1.2-0.9 2.1l-14.5 14.5q-0.9 0.8-2 0.8-1.2 0-2-0.8l-1.7-1.7q-0.9-0.8-0.9-2t0.9-2l6.5-6.6h-15.7q-1.1 0-1.9-0.8t-0.7-2v-2.9q0-1.2 0.7-2t1.9-0.9h15.7l-6.5-6.5q-0.9-0.8-0.9-2t0.9-2l1.7-1.7q0.8-0.9 2-0.9 1.2 0 2 0.9l14.5 14.5q0.9 0.8 0.9 2z' })
	        )
	    );
	};
	
	exports.default = FaArrowRight;
	module.exports = exports['default'];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendar = function FaCalendar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h6.4v-6.4h-6.4v6.4z m7.8 0h7.2v-6.4h-7.2v6.4z m-7.8-7.8h6.4v-7.2h-6.4v7.2z m7.8 0h7.2v-7.2h-7.2v7.2z m-7.8-8.6h6.4v-6.4h-6.4v6.4z m16.4 16.4h7.1v-6.4h-7.1v6.4z m-8.6-16.4h7.2v-6.4h-7.2v6.4z m17.2 16.4h6.4v-6.4h-6.4v6.4z m-8.6-7.8h7.1v-7.2h-7.1v7.2z m-7.9-19.3v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m16.5 19.3h6.4v-7.2h-6.4v7.2z m-8.6-8.6h7.1v-6.4h-7.1v6.4z m8.6 0h6.4v-6.4h-6.4v6.4z m0.7-10.7v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.2 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendar;
	module.exports = exports['default'];

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClockO = function FaClockO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23 12.1v10q0 0.4-0.2 0.6t-0.5 0.2h-7.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h5v-7.9q0-0.3 0.2-0.5t0.6-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m9.3 7.9q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaClockO;
	module.exports = exports['default'];

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUser = function FaUser(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 31.4q0 2.6-1.6 4.2t-4.3 1.5h-19.5q-2.7 0-4.4-1.5t-1.6-4.2q0-1.2 0.1-2.3t0.3-2.5 0.6-2.4 0.9-2.2 1.4-1.8 1.9-1.2 2.5-0.4q0.2 0 1 0.5t1.6 1 2.4 1.1 3 0.5 3-0.5 2.4-1.1 1.7-1 0.9-0.5q1.4 0 2.5 0.4t1.9 1.2 1.4 1.8 0.9 2.2 0.6 2.4 0.4 2.5 0 2.3z m-7.1-20q0 3.6-2.5 6.1t-6.1 2.5-6-2.5-2.6-6.1 2.6-6 6-2.5 6.1 2.5 2.5 6z' })
	        )
	    );
	};
	
	exports.default = FaUser;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(5);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bodytext = function Bodytext(props) {
	  var html = props.html,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: html }, className: _style2.default.dynamic([["1187744260", [theme.time.duration.long, theme.font.lineHeight.s, theme.font.size.l, theme.font.size.m, theme.font.lineHeight.m, theme.font.size.s, theme.font.lineHeight.xxl, theme.font.weight.bold, theme.color.brand.primary, theme.size.radius.default, theme.line.color, theme.color.neutral.gray.c]]]) + " " + "bodytext"
	    }),
	    _react2.default.createElement(_style2.default, {
	      styleId: "1187744260",
	      css: [".bodytext.__jsx-style-dynamic-selector{-webkit-animation-name:bodytextEntry;-webkit-animation-name:bodytextEntry-__jsx-style-dynamic-selector;animation-name:bodytextEntry-__jsx-style-dynamic-selector;-webkit-animation-duration:" + theme.time.duration.long + ";-webkit-animation-duration:" + theme.time.duration.long + ";animation-duration:" + theme.time.duration.long + ";}", ".bodytext.__jsx-style-dynamic-selector h2,.bodytext.__jsx-style-dynamic-selector h3{margin:1.5em 0 1em;}", ".bodytext.__jsx-style-dynamic-selector h2{line-height:" + theme.font.lineHeight.s + ";font-size:" + theme.font.size.l + ";}", ".bodytext.__jsx-style-dynamic-selector h3{font-size:" + theme.font.size.m + ";line-height:" + theme.font.lineHeight.m + ";}", ".bodytext.__jsx-style-dynamic-selector p{font-size:" + theme.font.size.s + ";line-height:" + theme.font.lineHeight.xxl + ";margin:0 0 1.5em;}", ".bodytext.__jsx-style-dynamic-selector ul{list-style:circle;margin:0 0 1.5em;padding:0 0 0 1.5em;}", ".bodytext.__jsx-style-dynamic-selector li{margin:0.7em 0;line-height:1.5;}", ".bodytext.__jsx-style-dynamic-selector a{font-weight:" + theme.font.weight.bold + ";color:" + theme.color.brand.primary + ";-webkit-text-decoration:underline;text-decoration:underline;}", ".bodytext.__jsx-style-dynamic-selector a.gatsby-resp-image-link,.bodytext.__jsx-style-dynamic-selector .gatsby-resp-image-wrapper{border:0;display:block;margin:2.5em 0;border-radius:" + theme.size.radius.default + ";overflow:hidden;border:1px solid " + theme.line.color + ";}", ".bodytext.__jsx-style-dynamic-selector code.language-text{background:" + theme.color.neutral.gray.c + ";text-shadow:none;color:inherit;padding:0.1em 0.3em 0.2em;border-radius:0.1em;}", "@-webkit-keyframes bodytextEntry{from.__jsx-style-dynamic-selector{opacity:0;}to.__jsx-style-dynamic-selector{opacity:1;}}", "@-webkit-keyframes bodytextEntry-__jsx-style-dynamic-selector{from{opacity:0;}to{opacity:1;}}", "@keyframes bodytextEntry-__jsx-style-dynamic-selector{from{opacity:0;}to{opacity:1;}}"],
	      dynamic: [theme.time.duration.long, theme.font.lineHeight.s, theme.font.size.l, theme.font.size.m, theme.font.lineHeight.m, theme.font.size.s, theme.font.lineHeight.xxl, theme.font.weight.bold, theme.color.brand.primary, theme.size.radius.default, theme.line.color, theme.color.neutral.gray.c]
	    })
	  );
	};
	
	Bodytext.propTypes = {
	  html: _propTypes2.default.string.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Bodytext;
	module.exports = exports["default"];

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = asyncComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function asyncComponent(getComponent, loadingComponent) {
	  var AsyncComponent = function (_React$Component) {
	    _inherits(AsyncComponent, _React$Component);
	
	    function AsyncComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AsyncComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { Component: null }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    AsyncComponent.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.state.Component) {
	        getComponent().then(function (Component) {
	          _this2.setState({ Component: Component });
	        });
	      }
	    };
	
	    AsyncComponent.prototype.render = function render() {
	      var Component = this.state.Component;
	
	      if (Component) {
	        return _react2.default.createElement(Component, this.props);
	      }
	      return loadingComponent ? loadingComponent : _react2.default.createElement(
	        "div",
	        null,
	        "Loading..."
	      );
	    };
	
	    return AsyncComponent;
	  }(_react2.default.Component);
	
	  return AsyncComponent;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AsyncComponent = __webpack_require__(475);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AsyncComponent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(5);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(55);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _avatar = __webpack_require__(410);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Author = function Author(props) {
	  var note = props.note,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        className: _style2.default.dynamic([["1199344449", [theme.space.l, theme.space.l, theme.line.color, theme.line.color, theme.line.color]]]) + " " + "author"
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: _style2.default.dynamic([["1199344449", [theme.space.l, theme.space.l, theme.line.color, theme.line.color, theme.line.color]]]) + " " + "avatar"
	        },
	        _react2.default.createElement("img", { src: _avatar2.default, alt: _config2.default.siteTitle, className: _style2.default.dynamic([["1199344449", [theme.space.l, theme.space.l, theme.line.color, theme.line.color, theme.line.color]]])
	        })
	      ),
	      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: note }, className: _style2.default.dynamic([["1199344449", [theme.space.l, theme.space.l, theme.line.color, theme.line.color, theme.line.color]]]) + " " + "note"
	      })
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "1199344449",
	      css: [".author.__jsx-style-dynamic-selector{margin:" + theme.space.l + " 0;padding:" + theme.space.l + " 0;border-top:1px solid " + theme.line.color + ";border-bottom:1px solid " + theme.line.color + ";}", ".avatar.__jsx-style-dynamic-selector{float:left;border-radius:65% 75%;border:1px solid " + theme.line.color + ";display:inline-block;height:50px;margin:5px 20px 0 0;overflow:hidden;width:50px;}", ".avatar.__jsx-style-dynamic-selector img.__jsx-style-dynamic-selector{width:100%;}", ".note.__jsx-style-dynamic-selector{font-size:0.9em;line-height:1.6;}", "@media screen and (min-width:600px){.author.__jsx-style-dynamic-selector{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}.avatar.__jsx-style-dynamic-selector{-webkit-box-flex:0;-ms-flex:0 0 auto;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;}}"],
	      dynamic: [theme.space.l, theme.space.l, theme.line.color, theme.line.color, theme.line.color]
	    })
	  );
	};
	
	Author.propTypes = {
	  note: _propTypes2.default.string.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Author;
	module.exports = exports["default"];

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(5);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(55);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _kebabCase = __webpack_require__(258);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _calendar = __webpack_require__(267);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _user = __webpack_require__(269);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _tag = __webpack_require__(83);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _clockO = __webpack_require__(268);
	
	var _clockO2 = _interopRequireDefault(_clockO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meta = function Meta(props) {
	  var prefix = props.prefix,
	      authorName = props.author,
	      category = props.category,
	      tags = props.tags,
	      theme = props.theme,
	      timeToRead = props.timeToRead;
	
	
	  var primaryMenu = _config2.default.primaryMenu;
	  var idx = primaryMenu.findIndex(function (menuItem) {
	    return menuItem.to == "/categories/";
	  });
	  var categoryMenuEnabled = primaryMenu[idx].enabled;
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]]) + " " + "meta"
	    },
	    _react2.default.createElement(
	      "span",
	      {
	        className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]])
	      },
	      _react2.default.createElement(_calendar2.default, { size: 18 }),
	      " ",
	      prefix
	    ),
	    _config2.default.showAuthorName && authorName && _react2.default.createElement(
	      "span",
	      {
	        className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]])
	      },
	      _react2.default.createElement(_user2.default, { size: 18 }),
	      " ",
	      authorName
	    ),
	    categoryMenuEnabled && category && _react2.default.createElement(
	      "span",
	      {
	        className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]])
	      },
	      _react2.default.createElement(_tag2.default, { size: 18 }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/categories/" + category },
	        category
	      )
	    ),
	    _react2.default.createElement(
	      "span",
	      {
	        className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]])
	      },
	      _react2.default.createElement(_clockO2.default, { size: 18 }),
	      timeToRead,
	      " min. read"
	    ),
	    _react2.default.createElement(
	      "ul",
	      {
	        className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]])
	      },
	      tags && tags.map(function (tag, i) {
	        return _react2.default.createElement(
	          "li",
	          { key: (0, _kebabCase2.default)(tag), className: _style2.default.dynamic([["2502030607", [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]]])
	          },
	          _react2.default.createElement(_tag2.default, { size: 18 }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/tags/" + (0, _kebabCase2.default)(tag) },
	            tag
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "2502030607",
	      css: [".meta.__jsx-style-dynamic-selector{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;font-size:0.8em;margin:" + theme.space.m + " 0;background:transparent;}", ".meta.__jsx-style-dynamic-selector svg{fill:" + theme.icon.color + ";margin:" + theme.space.inline.xs + ";}", ".meta.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;text-transform:uppercase;margin:" + theme.space.xs + " " + theme.space.s + " " + theme.space.xs + " 0;}", ".meta.__jsx-style-dynamic-selector ul.__jsx-style-dynamic-selector{display:inherit;list-style-type:none;margin:" + theme.space.xs + " " + theme.space.s + " " + theme.space.xs + " 0;}", ".meta.__jsx-style-dynamic-selector li.__jsx-style-dynamic-selector{padding:0px 5px;text-transform:uppercase;}", "@media screen and (min-width:600px){.meta.__jsx-style-dynamic-selector{margin:" + ("calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m) + ";}}"],
	      dynamic: [theme.space.m, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.xs, theme.space.s, theme.space.xs, "calc(" + theme.space.m + " * 1.5) 0 " + theme.space.m]
	    })
	  );
	};
	
	Meta.propTypes = {
	  prefix: _propTypes2.default.string.isRequired,
	  author: _propTypes2.default.string.isRequired,
	  category: _propTypes2.default.string,
	  tags: _propTypes2.default.any,
	  theme: _propTypes2.default.object.isRequired,
	  timeToRead: _propTypes2.default.number
	};
	
	exports.default = Meta;
	module.exports = exports["default"];

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(5);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowRight = __webpack_require__(266);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _arrowLeft = __webpack_require__(923);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextPrev = function NextPrev(props) {
	  var theme = props.theme,
	      _props$next = props.next;
	  _props$next = _props$next === undefined ? {} : _props$next;
	  var _props$next$fields = _props$next.fields;
	  _props$next$fields = _props$next$fields === undefined ? {} : _props$next$fields;
	  var nextPrefix = _props$next$fields.prefix,
	      nextSlug = _props$next$fields.slug,
	      _props$next$frontmatt = _props$next.frontmatter;
	  _props$next$frontmatt = _props$next$frontmatt === undefined ? {} : _props$next$frontmatt;
	  var nextTitle = _props$next$frontmatt.title,
	      _props$prev = props.prev;
	  _props$prev = _props$prev === undefined ? {} : _props$prev;
	  var _props$prev$fields = _props$prev.fields;
	  _props$prev$fields = _props$prev$fields === undefined ? {} : _props$prev$fields;
	  var prevPrefix = _props$prev$fields.prefix,
	      prevSlug = _props$prev$fields.slug,
	      _props$prev$frontmatt = _props$prev.frontmatter;
	  _props$prev$frontmatt = _props$prev$frontmatt === undefined ? {} : _props$prev$frontmatt;
	  var prevTitle = _props$prev$frontmatt.title;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        className: _style2.default.dynamic([["782681884", [theme.space.m, theme.space.l, theme.line.color, theme.space.stack.l, theme.space.default, theme.color.special.attention, theme.space.m, theme.space.m, theme.space.inline.m, theme.color.neutral.gray.g, theme.space.inline.s]]]) + " " + "links"
	      },
	      nextSlug && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: nextSlug },
	        _react2.default.createElement(_arrowRight2.default, null),
	        _react2.default.createElement(
	          "h4",
	          {
	            className: _style2.default.dynamic([["782681884", [theme.space.m, theme.space.l, theme.line.color, theme.space.stack.l, theme.space.default, theme.color.special.attention, theme.space.m, theme.space.m, theme.space.inline.m, theme.color.neutral.gray.g, theme.space.inline.s]]])
	          },
	          nextTitle,
	          " ",
	          _react2.default.createElement(
	            "time",
	            {
	              className: _style2.default.dynamic([["782681884", [theme.space.m, theme.space.l, theme.line.color, theme.space.stack.l, theme.space.default, theme.color.special.attention, theme.space.m, theme.space.m, theme.space.inline.m, theme.color.neutral.gray.g, theme.space.inline.s]]])
	            },
	            nextPrefix,
	            " "
	          )
	        )
	      ),
	      prevSlug && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: prevSlug },
	        _react2.default.createElement(_arrowLeft2.default, null),
	        _react2.default.createElement(
	          "h4",
	          {
	            className: _style2.default.dynamic([["782681884", [theme.space.m, theme.space.l, theme.line.color, theme.space.stack.l, theme.space.default, theme.color.special.attention, theme.space.m, theme.space.m, theme.space.inline.m, theme.color.neutral.gray.g, theme.space.inline.s]]])
	          },
	          prevTitle,
	          " ",
	          _react2.default.createElement(
	            "time",
	            {
	              className: _style2.default.dynamic([["782681884", [theme.space.m, theme.space.l, theme.line.color, theme.space.stack.l, theme.space.default, theme.color.special.attention, theme.space.m, theme.space.m, theme.space.inline.m, theme.color.neutral.gray.g, theme.space.inline.s]]])
	            },
	            prevPrefix
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "782681884",
	      css: [".links.__jsx-style-dynamic-selector{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;padding:0 " + theme.space.m + " " + theme.space.l + ";border-bottom:1px solid " + theme.line.color + ";margin:" + theme.space.stack.l + ";}", ".links.__jsx-style-dynamic-selector a{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".links.__jsx-style-dynamic-selector a:nth-child(2){margin:" + theme.space.default + " 0 0;}", ".links.__jsx-style-dynamic-selector svg{fill:" + theme.color.special.attention + ";width:" + theme.space.m + ";height:" + theme.space.m + ";-ms-flex-negative:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:0;-ms-flex-positive:0;-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;margin:" + theme.space.inline.m + ";}", "h4.__jsx-style-dynamic-selector{font-weight:600;margin:0;font-size:1.1em;}", "time.__jsx-style-dynamic-selector{color:" + theme.color.neutral.gray.g + ";display:block;font-weight:400;font-size:0.8em;margin-top:0.5em;}", "@media screen and (min-width:1024px){.links.__jsx-style-dynamic-selector{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;-webkit-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}.links.__jsx-style-dynamic-selector a{-ms-flex-preferred-size:50%;-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;}.links.__jsx-style-dynamic-selector a:nth-child(2){margin:0;}.links.__jsx-style-dynamic-selector svg{-webkit-transition:all 0.5s;-webkit-transition:all 0.5s;transition:all 0.5s;margin:" + theme.space.inline.s + ";}@media (hover:hover){.links.__jsx-style-dynamic-selector a:hover svg{-webkit-transform:scale(1.5);-webkit-transform:scale(1.5);-ms-transform:scale(1.5);transform:scale(1.5);}}}"],
	      dynamic: [theme.space.m, theme.space.l, theme.line.color, theme.space.stack.l, theme.space.default, theme.color.special.attention, theme.space.m, theme.space.m, theme.space.inline.m, theme.color.neutral.gray.g, theme.space.inline.s]
	    })
	  );
	};
	
	NextPrev.propTypes = {
	  next: _propTypes2.default.object,
	  prev: _propTypes2.default.object,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = NextPrev;
	module.exports = exports["default"];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(334);
	
	var _AsyncComponent = __webpack_require__(476);
	
	var _AsyncComponent2 = _interopRequireDefault(_AsyncComponent);
	
	var _Headline = __webpack_require__(68);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Bodytext = __webpack_require__(167);
	
	var _Bodytext2 = _interopRequireDefault(_Bodytext);
	
	var _Meta = __webpack_require__(495);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Author = __webpack_require__(494);
	
	var _Author2 = _interopRequireDefault(_Author);
	
	var _NextPrev = __webpack_require__(496);
	
	var _NextPrev2 = _interopRequireDefault(_NextPrev);
	
	var _gatsbyPluginTalkyard = __webpack_require__(411);
	
	var _gatsbyPluginTalkyard2 = _interopRequireDefault(_gatsbyPluginTalkyard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Share = (0, _AsyncComponent2.default)(function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	      resolve(__webpack_require__(498));
	    });
	  }).then(function (module) {
	    return module;
	  }).catch(function (error) {});
	});
	
	var Post = function Post(props) {
	  var post = props.post,
	      _props$post = props.post,
	      html = _props$post.html,
	      timeToRead = _props$post.timeToRead,
	      prefix = _props$post.fields.prefix,
	      _props$post$frontmatt = _props$post.frontmatter,
	      title = _props$post$frontmatt.title,
	      category = _props$post$frontmatt.category,
	      author = _props$post$frontmatt.author,
	      tags = _props$post$frontmatt.tags,
	      authornote = props.authornote,
	      nextPost = props.next,
	      prevPost = props.prev,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "header",
	      null,
	      _react2.default.createElement(_Headline2.default, { title: title, theme: theme }),
	      _react2.default.createElement(_Meta2.default, {
	        prefix: prefix,
	        author: author,
	        category: category,
	        tags: tags,
	        theme: theme,
	        timeToRead: timeToRead
	      })
	    ),
	    _react2.default.createElement(_Bodytext2.default, { html: html, theme: theme }),
	    _react2.default.createElement(
	      "footer",
	      null,
	      _react2.default.createElement(Share, { post: post, theme: theme }),
	      _react2.default.createElement(_Author2.default, { note: authornote, theme: theme }),
	      _react2.default.createElement(_NextPrev2.default, { next: nextPost, prev: prevPost, theme: theme })
	    ),
	    _react2.default.createElement(_gatsbyPluginTalkyard2.default, null)
	  );
	};
	
	Post.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  authornote: _propTypes2.default.string.isRequired,
	  next: _propTypes2.default.object,
	  prev: _propTypes2.default.object,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Post;
	module.exports = exports["default"];

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Post = __webpack_require__(497);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Post).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(57);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Article = __webpack_require__(56);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Post = __webpack_require__(499);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _layouts = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(334);
	
	var PostTemplate = function PostTemplate(props) {
	  var _props$data = props.data,
	      post = _props$data.post,
	      authorNote = _props$data.authornote.html,
	      facebook = _props$data.site.siteMetadata.facebook,
	      _props$pathContext = props.pathContext,
	      next = _props$pathContext.next,
	      prev = _props$pathContext.prev;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _layouts.ThemeContext.Consumer,
	      null,
	      function (theme) {
	        return _react2.default.createElement(
	          _Article2.default,
	          { theme: theme },
	          _react2.default.createElement(_Post2.default, {
	            post: post,
	            next: next,
	            prev: prev,
	            authornote: authorNote,
	            facebook: facebook,
	            theme: theme
	          })
	        );
	      }
	    ),
	    _react2.default.createElement(_Seo2.default, { data: post, facebook: facebook })
	  );
	};
	
	PostTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	};
	
	exports.default = PostTemplate;
	
	//eslint-disable-next-line no-undef
	
	var postQuery = exports.postQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-template-js-db414e88028e42a90099.js